import { render, staticRenderFns } from "./download-status-box.vue?vue&type=template&id=2bc97c56&scoped=true&"
import script from "./download-status-box.vue?vue&type=script&lang=js&"
export * from "./download-status-box.vue?vue&type=script&lang=js&"
import style0 from "./download-status-box.vue?vue&type=style&index=0&id=2bc97c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc97c56",
  null
  
)

export default component.exports